import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';
import lang from '../../../../assets/i18n/en.json';
import { useLocation, useNavigate } from 'react-router-dom';
import { InputSwitch } from 'primereact/inputswitch';
import { useEffect, useState, useCallback } from 'react';
import { useQuery, useMutation, useApolloClient } from '@apollo/client';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import allImages from '../../../../assets/images/allImages';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmationPopup } from '../../../Common/confirmationPopup/ConfirmationPopup';
import { EditUserDetails } from '../../EnterpriseAdmin/userManagement/EditUserDetails';
import {
  GetEnterpriseClientByIdV2,
  GetEnterpriseByIDV2,
} from '../../../../Queries/QueriesUpdated';
import { isLogout } from '../../../../Redux/authSlice';
import { setLoaderFalse, setLoaderTrue } from '../../../../Redux/loaderSlice';
import { globalError } from '../../../../utils/global-error-handler';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateClient, UpdateClientUser } from '../../../../Mutations/MutationsUpdated';

export const EnterpriseActivity = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const rowDetails = location.state.selectedRowData;
  const ERROR = lang.ERROR;
  const client = useApolloClient();
  const [checkIsActive, setCheckIsActive] = useState();
  const [singleEnterprise, setSingleEnterprise] = useState({});
  const [singleEnterpriseClients, setSingleEnterpriseClients] = useState([]);
  // const [selectedRole, setSelectedRole] = useState({});
  const [singleEnterpriseStatus, setSignleEnterpriseStatus] = useState();
  const [selectedRow, setSelectedRow] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [showConfirm, setConfirm] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [apiError, setApiError] = useState(false);

  const authReducer = useSelector((state) => state.authReducer);

  const [confirmationPopupLabelFor, setConfirmationPopupLabelFor] = useState();
  const [onChangeSelectedRole, setOnchangeSelectedRole] = useState();
  const roleOptions = [
    { value: 'ENTERPRISE_ADMIN', key: 'ENTERPRISE_ADMIN' },
    { value: 'ENTERPRISE_USER', key: 'ENTERPRISE_USER' },
  ];

  const [filters, setFilter] = useState({
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });

  const roleBody = (rowData) => {
    return (
      <>
        <Dropdown
          placeholder={rowData.role}
          value={rowData.role}
          onChange={(e) => {
            rowData.role === e.value ? setConfirm(false) : setConfirm(true);
            setSelectedRow(rowData);
            setConfirmationPopupLabelFor('');
            setOnchangeSelectedRole(e.value);
          }}
          options={roleOptions}
          optionLabel="value"
          style={{ width: '90%' }}
        />
      </>
    );
  };

  const nameBody = (rowData) => {
    const fullName = rowData.firstName.concat(' ', rowData.lastName);
    return (
      <>
        <div>{fullName}</div>
      </>
    );
  };

  const { loading,refetch } = useQuery(GetEnterpriseByIDV2);

  //Assign mutaions to variable
  const [checkEnterpriseStatus] = useMutation(
    UpdateClient,
    {
      onCompleted: (data) => {
        // const updatedData = data?.updateStatusByEnterpriseId;
        // updatedData.createdOn = new Date(
        //   updatedData?.createdOn,
        // ).toLocaleDateString('en-US', {
        //   month: 'long',
        //   day: 'numeric',
        //   year: 'numeric',
        // });
        // setSingleEnterprise(updatedData);
      },

      onError: ({ graphQLErrors }) => {
        if (graphQLErrors[0].extensions.response) {
          if (
            graphQLErrors[0].extensions.response.statusText === 'Unauthorized'
          )
            // Check if any of the GraphQL errors have a 401 status code
            toast.error(
              toastResponse(
                'error',
                ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST,
              ),
            );
        } else {
          toast.error(toastResponse('error', graphQLErrors[0].message));
        }
      },
    },
  );

  //Assign mutaions to variable
  const [checkClientRole] =
    useMutation(UpdateClientUser, {
      onCompleted: (data) => {
        setApiError(false);
        setSingleEnterpriseClients(
          singleEnterpriseClients.map((item) =>
            item.id === data.updateEnterpriseClientRoleById.id
              ? { ...item, role: data.updateEnterpriseClientRoleById.role }
              : item,
          ),
        );
      },

      onError: ({ graphQLErrors }) => {
        setApiError(true);
        if (graphQLErrors[0].extensions.response) {
          if (
            graphQLErrors[0].extensions.response.statusText === 'Unauthorized'
          )
            // Check if any of the GraphQL errors have a 401 status code
            toast.error(
              toastResponse(
                'error',
                ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST,
              ),
            );
        } else {
          toast.error(toastResponse('error', graphQLErrors[0].message));
        }
      },
    });

  const fetchSingleEnterpriseDetails = useCallback(async () => {
    refetch();

    //Animated Loader true
    dispatch(setLoaderTrue());
    try {
      const { data } = await client.query({
        query: GetEnterpriseByIDV2,
        variables: {
          clientId: rowDetails.id,
        },
      });

      if (data) {
        let selectedData = data?.getEnterpriseUser;
        selectedData = JSON.parse(JSON.stringify(selectedData));
        selectedData.createdOn = new Date(
          selectedData?.createdOn,
        ).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        });
        selectedData.status === 'ACTIVE'
          ? setCheckIsActive(true)
          : setCheckIsActive(false);
        setSingleEnterprise(selectedData);

        const singleEnterpriseClientsData =
          data?.getClientUsersByClientId;
        setSingleEnterpriseClients(singleEnterpriseClientsData.map(e=> ({...e, phoneNumber: e?.phones?.length ? e.phones[0].phoneNumber: ''})));

        setSignleEnterpriseStatus({
          active: data?.getEmployeeStatsByClientId?.active ?? 0,
          registered: data?.getEmployeeStatsByClientId?.registered ?? 0,
          total: data?.getEmployeeStatsByClientId?.total ?? 0,
          invited: data?.getEmployeeStatsByClientId?.invited ?? 0
        });
      }

      //Animated Loader false
      dispatch(setLoaderFalse());
    } catch (error) {
      // if (error.networkError.statusCode) {
      //   const errorDetails = globalError(error.networkError.statusCode);
      //   toast.error(toastResponse('error', errorDetails.message));

      //   dispatch(isLogout());
      //   // navigate("/user/login");
        
      //   setTimeout(() => {
      //     window.location.href = '/user/login';
      //   }, 500);
      // }
      //Animated Loader false
      dispatch(setLoaderFalse());

      console.error('Error in fetching enterprise list', error);
    }
  },[client, dispatch, refetch, rowDetails.id]);

  useEffect(() => {
    fetchSingleEnterpriseDetails();
  }, [rowDetails, fetchSingleEnterpriseDetails]);

  const handleRowSelect = async (rowData) => {
    let checkParentNodeName =
      rowData.originalEvent.target?.parentNode?.className;
    if (
      checkParentNodeName.includes('p-dropdown') ||
      checkParentNodeName === 'p-dropdown-item' ||
      checkParentNodeName === 'p-dropdown-trigger'
    ) {
      setShowEdit(false);
    } else {
      try {
        // const { data } = await client.query({
        //   query: GetEnterpriseClientByIdV2,
        //   variables: { clientId: rowData.data.clientId },
        // });
        // setSelectedRow(data.getClientUsersByClientId);
        setSelectedRow(rowData.data);
        setShowEdit(true);
      } catch (error) {
        console.error('Error fetching user list', error);
      }
    }
  };

  const fnHandleStatusToggle = (checkStatus) => {
    setCheckIsActive(checkStatus);
    setConfirm(false);

    //Call mutaion with parameter
    checkEnterpriseStatus({
      variables: {
        updateClientId: rowDetails.id,
        input: {status : checkStatus ? 'ACTIVE' : 'INACTIVE'},
      },
    });
  };

  const fnHandleRoleChange = async () => {
    try {
      setConfirm(false);

      if (selectedRow) {
        //Call mutaion with parameter
        checkClientRole({
          variables: {
            updateClientUserId: selectedRow.id,
            input: {role: onChangeSelectedRole},
          },
        });
      } else {
        setShowEdit(false);
      }
    } catch (error) {
      console.error('Error fetching user list', error);
    }
  };

  return (
    <>
      <div className="row pt-4">
        <div className="col-md-12">
          <div className="breadcrumbs">
            <button
              type="button"
              className="theme breadcrumbs-links btn btn-link p-0"
              onClick={() => navigate('/enterprise/bond-admin/dashboard')}
            >
              Dashboard{' '}
            </button>
            <button
              type="button"
              className="theme breadcrumbs-links btn btn-link p-0"
            >
              {' '}
              Enterprise Activity
            </button>
          </div>
        </div>
      </div>
      <div className="row pt-4">
        <div className="col-md-8">
          <h4 className="fw-bolder">{singleEnterprise.name}</h4>
          <div className="text-muted">
            <span>Created on {singleEnterprise.createdOn} | </span>
            <span>
              {singleEnterprise.status}
              <InputSwitch
                checked={checkIsActive}
                style={{ verticalAlign: 'middle', marginLeft: '1rem' }}
                // onChange={(e) => { setConfirmationFlag(false); setConfirm(true); setCheckIsActive(e.value) }}
                onChange={(e) => {
                  setConfirm(true);
                  setConfirmationPopupLabelFor('activeenterprise');
                }}
              />
            </span>
          </div>
        </div>
        <div className="col-md-4 text-center">
          <div
            className="totalEnterpriseBlock float-end"
            style={{ width: '80%' }}
          >
            <div className="blockTitle fw-bolder">Total Employees</div>
            <div className="blockNumber">
              {singleEnterpriseStatus ? singleEnterpriseStatus.total : 'NA'}
            </div>
          </div>
        </div>
      </div>
      <div className="row enterpriseDetails block ">
        <div className="col-md-12">
          <div className="enterpriseDetails appDetails">
            <h6 className="fw-bolder mb-0">App Details</h6>
          </div>
        </div>
        <div className="col-md-12 text-center">
          <div className="row pt-3">
            <div className="col-md-4">
              <h6 className="fw-bolder">Registered Employees</h6>
              <div className="blockNumber">
                {singleEnterpriseStatus
                  ? singleEnterpriseStatus.registered
                  : 'NA'}
              </div>
            </div>
            <div className="col-md-4">
              <h6 className="fw-bolder">Active Employees</h6>
              <div className="blockNumber">
                {singleEnterpriseStatus ? singleEnterpriseStatus.active : 'NA'}
              </div>
            </div>
            <div className="col-md-4">
              <h6 className="fw-bolder">Total Invites Sent</h6>
              <div className="blockNumber">
                {singleEnterpriseStatus
                  ? singleEnterpriseStatus.invited
                  : 'NA'}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0 customTable border">
        <div className="col-md-12">
          <div className="row customTable mainheader">
            <div className="col-md-8">
              <div className="customTable title">
                <label>Users</label>
              </div>
            </div>
            <div className="col-md-4">
              <div className="search-field position-relative">
                <div className="customTable static-search-mg">
                  <img
                    src={allImages.search}
                    className="img-fluid"
                    style={{ height: '1.2rem' }}
                    alt="search_icon"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Search"
                  className="form-control customTable custom-input-field"
                  value={globalFilterValue}
                  onChange={(e) => {
                    setFilter((filters) => ({
                      ...filters,
                      global: {
                        ...filters['global'],
                        value: e?.target?.value.trim(),
                      },
                    }));
                    setGlobalFilterValue(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 p-0">
          <DataTable
            value={singleEnterpriseClients}
            rows={10}
            style={{ zIndex: '0' }}
            removableSort
            onRowClick={handleRowSelect}
            className="customTable tableHeight"
            paginator="true"
            paginatorPosition="bottom"
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            rowHover="true"
            scrollable
            scrollHeight="flex"
            resizableColumns="true"
            globalFilterFields={[
              'firstName',
              'lastName',
              'role',
              'email',
              'status',
              'phoneNumber',
            ]}
            filters={filters}
            emptyMessage={
              loading && (
                <h5 className="text-center h-100  pt-4 fw-bolder w-100">
                  There is no data to display at the moment.
                </h5>
              )
            }
            responsiveLayout="scroll"
          >
            <Column
              field="name"
              header="Full Name"
              body={nameBody}
              sortable
            />
            <Column
              field="role"
              header="Role"
              body={roleBody}
              // style={{ maxWidth: '40%' }}
              sortable
            />
            <Column field="email" header="Email" sortable />
            <Column field="status" header="Status" style={{ maxWidth: '10%' }} sortable />
            <Column field="phoneNumber" header="Phone Number" sortable />
          </DataTable>
        </div>
      </div>

      <ConfirmationPopup
        showConfirm={showConfirm}
        onConfirmHide={() => setConfirm(false)}
        headerText={
          confirmationPopupLabelFor === 'activeenterprise'
            ? `Enterprise ${checkIsActive ? 'Inactive' : 'Active'} Confirmation`
            : `Employee Role Change Confirmation`
        }
        modalBody={
          confirmationPopupLabelFor === 'activeenterprise'
            ? `Are you certain about marking this Enterprise as ${checkIsActive ? "'inactive'" : "'active'"} Once they are marked as inactive, they will no longer have access to the app.`
            : `Are you sure you want to change ${selectedRow.firstName + ' ' + selectedRow.lastName + "'s"} role from ${selectedRow.role} to ${onChangeSelectedRole}?`
        }
        otherBtnText={
          confirmationPopupLabelFor === 'activeenterprise'
            ? `Mark as  ${checkIsActive ? 'Inactive' : 'Active'}`
            : `Confirm`
        }
        activeToggle={checkIsActive}
        type={'enterpriseActive'}
        onConfirmStatus={() =>
          confirmationPopupLabelFor === 'activeenterprise'
            ? fnHandleStatusToggle(!checkIsActive)
            : fnHandleRoleChange()
        }
        checkError={apiError}
      />

      <EditUserDetails
        showEdit={showEdit}
        onEditHide={() => setShowEdit(false)}
        selectedRow={selectedRow}
        type="enterprise"
        refetch={() =>
          (window.location.href = '/enterprise/bond-admin/enterprise-activity')
        }
      />
    </>
  );
};
